import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import type { BoolFilter } from '@sbt-web/network/types';
import { FormGroup, Toggle } from '@sbt-web/ui';
import { FilterLabel } from '../common/FilterLabel';
import type { CommonFilterProps } from '../common/types';
import commonClasses from '../common/styles.module.scss';
type Props = CommonFilterProps & {
  filter: BoolFilter;
  initialValue?: string;
  onSelect: (key: string, value?: string, label?: string) => void;
};
export const BoolSelector: FC<Props> = t0 => {
  const $ = _c(16);
  const {
    filter,
    initialValue,
    showBadgeNew,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== filter.label || $[1] !== filter.queryString || $[2] !== onSelect) {
    t1 = selected => onSelect(filter.queryString, selected ? "true" : undefined, selected ? filter.label : undefined);
    $[0] = filter.label;
    $[1] = filter.queryString;
    $[2] = onSelect;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleSelection = t1;
  let t2;
  if ($[4] !== filter.label || $[5] !== showBadgeNew) {
    t2 = <FilterLabel showBadgeNew={showBadgeNew}>{filter.label}</FilterLabel>;
    $[4] = filter.label;
    $[5] = showBadgeNew;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = initialValue != undefined;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [commonClasses["custom-toggle"]];
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = filter.subLabel ?? filter.label;
  let t6;
  if ($[8] !== filter.uri || $[9] !== handleSelection || $[10] !== t3 || $[11] !== t5) {
    t6 = <Toggle name={filter.uri} checked={t3} onInputChange={handleSelection} spaceBetweenElements={true} classes={t4}>{t5}</Toggle>;
    $[8] = filter.uri;
    $[9] = handleSelection;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t6) {
    t7 = <FormGroup>{t2}{t6}</FormGroup>;
    $[13] = t2;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};